import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import { useIntl } from "react-intl";

import { Typography } from "@material-ui/core";

import { Flex, Loading } from "../../../../../_common";
import { TIPO_CONTATO } from "../../_common/constantes";

const style = () => ({
  listaLeads: {
    paddingTop: 8,
  },
  containerSemLeads: {
    marginTop: "65%",
  },
  textoSemLeads: {
    fontStyle: "italic",
    color: "#a5aab4",
  },
  containerLead: {
    width: "100%",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    padding: 24,
    borderRadius: 8,
    marginBottom: 12,
  },
  tituloLead: {
    marginBottom: 8,
  },
});

const mensagemContato = (contato, campo, intl) =>
  contato[campo] ??
  intl.formatMessage({ defaultMessage: "O contato {nome} não possui {tipo}" }, { nome: contato.nome, tipo: campo });

function ListaLeadsAtividades({ reloadContatos, atividades, contatosId, isEnvioWhatsApp, classes }) {
  const intl = useIntl();

  const retornarContato = contatosLeadAtividade => {
    if (contatosLeadAtividade?.length > 0) {
      const campo = isEnvioWhatsApp ? TIPO_CONTATO.TELEFONE : TIPO_CONTATO.EMAIL;
      return mensagemContato(contatosLeadAtividade.find(i => i.principal) ?? contatosLeadAtividade[0], campo, intl);
    }

    return intl.formatMessage({ defaultMessage: "Este lead não possui contatos" });
  };

  const renderContatoInfo = contato => (
    <Flex key={contato.id}>
      <Typography variant="subtitle1">
        {contato[isEnvioWhatsApp ? TIPO_CONTATO.TELEFONE : TIPO_CONTATO.EMAIL] ??
          intl.formatMessage(
            { defaultMessage: "O contato {nome} não possui {tipo}" },
            { nome: contato.nome, tipo: isEnvioWhatsApp ? TIPO_CONTATO.TELEFONE : TIPO_CONTATO.EMAIL }
          )}
      </Typography>
    </Flex>
  );

  return (
    <Flex alignItems="center" flexDirection="column" className={classes.listaLeads}>
      <Loading isLoading={reloadContatos}>
        {atividades?.filter(item => item.lead).map(item => {
          const contatos = contatosId != null ? item.lead?.contatos : item.lead?.contatosLead;

          return (
            <Flex key={item.id} id="container-lead" flexDirection="column" className={classes.containerLead}>
              <Flex>
                <Typography variant="h5" className={classes.tituloLead}>
                  {item.lead?.nome}
                </Typography>
              </Flex>

              {contatos?.length > 0 ? (
                contatos.map(renderContatoInfo)
              ) : (
                <Flex>
                  <Typography variant="subtitle1">
                    {contatosId != null
                      ? retornarContato(item.lead?.contatosLead)
                      : intl.formatMessage({
                          defaultMessage: "Este lead não possui contatos",
                        })}
                  </Typography>
                </Flex>
              )}
            </Flex>
          );
        })}

        {atividades?.filter(x => x.lead).length === 0 && (
          <Flex flexDirection="column" className={classes.containerSemLeads}>
            <Typography variant="subtitle1" className={classes.textoSemLeads}>
              {intl.formatMessage({ defaultMessage: "Nenhum contato encontrado" })}
            </Typography>
          </Flex>
        )}
      </Loading>
    </Flex>
  );
}

ListaLeadsAtividades.propTypes = {
  atividades: PropTypes.array,
  reloadContatos: PropTypes.bool,
  contatosId: PropTypes.array,
  isEnvioWhatsApp: PropTypes.bool,
};

export default injectSheet(style)(ListaLeadsAtividades);
